import React from "react"
import CookieConsent, { Cookies } from "react-cookie-consent"
import { Link } from "gatsby"

// styles
import * as Styled from "./cookie.styles"

const Cookie = props => {
  // loads ga only when user accepts cookies
  const consent = () => {
    localStorage.setItem("gtag_optin", true)
    if (typeof window.loadGtag == "function") {
      window.loadGtag()
    }
  }

  return (
    typeof window !== "undefined" &&
    !props.visible && (
      <CookieConsent
        buttonStyle={{ visibility: "hidden", display: "none" }}
        style={{
          background: "#593ba0",
          margin: "0",
        }}
      >
        <Styled.Content>
          <p>
            Unsere Website verwendet eigene Cookies und Cookies von Dritten um
            Ihnen den bestmöglichen Service zu bieten. Weiteres erfahren Sie
            unter:{" "}
            <Link to="/datenschutz" style={{ color: "#d59f08" }}>
              Datenschutz
            </Link>
            .{"   "}Hier finden Sie unser{" "}
            <Link to="/impressum" style={{ color: "#d59f08" }}>
              Impressum
            </Link>
            .
          </p>
          <Styled.ButtonContainer>
            <button
              onClick={() => {
                Cookies.set("gaRecaptcha", false, {
                  expires: new Date("2099"),
                })
                Cookies.set("gaCookie", false, { expires: new Date("2099") })
                localStorage.setItem("gtag_optin", false)
                Cookies.remove("_ga")
                Cookies.remove("_ga_BDZJ4ZQZ2W")
                Cookies.remove("_gat_gtag_UA_209521596_1")
                Cookies.remove("_gid")
                props.onClick(true)
                window.location.reload()
              }}
            >
              Ablehnen
            </button>
            <button
              onClick={() => {
                Cookies.set("gaCookie", true, { expires: new Date("2099") })
                Cookies.set("gaRecaptcha", true, {
                  expires: new Date("2099"),
                })
                consent()
                props.onClick(true)
                window.location.reload()
              }}
            >
              Akzeptieren
            </button>
          </Styled.ButtonContainer>
        </Styled.Content>
      </CookieConsent>
    )
  )
}

export default Cookie
